var $ = require('jquery');
var Marionette = require('marionette');

var Layout = Marionette.View.extend({
    template: '#dialogCustomLayout',
    events: {
        'click @ui.cancel,@ui.close': 'cancel',
        'click @ui.save': 'save'
    },
    regions: {
        header: '#modalHeader',
        body: '#body',
        footer: '#modalFooter'
    },
    ui: {
        cancel: '#cancel',
        close: '#close',
        dialog: '#dialog',
        save: '#save',
        modalDialog: "#modalDialog",
        body:'#body',
        header: '#modalHeader',
        footer: '#modalFooter'
    },
    initialize: function () {
        this.listenTo(this.options.view, 'close:dialog', this.cancel);
    },
    onRender: function () {
        this.ui.dialog.modal('show');
        if (!this.ui.close.html()) {
            this.ui.close.addClass('hidden');
        }
        if (!this.ui.cancel.html()) {
            this.ui.cancel.addClass('hidden');
        }
        if (!this.ui.save.html()) {
            this.ui.save.addClass('hidden');
        }
        this.ui.modalDialog.addClass(this.options.size);
        this.ui.body.addClass(this.options.modalBodyClass);
        this.ui.dialog.addClass(this.options.modalClass);
    }
});

// Expects a view to render in the dialog body. Optionally provide labels and a backbone model if it needs to be validated before resolving the promise.
module.exports.show = function (options) {
    var close = options.showCloseBtn;
    var cancel = options.cancelLabel;
    var size = options.size || "modal-md";
    var header = options.headerLabel || '{Header}';
    var save = options.saveLabel;
    var validate = options.validate;
    var validateOnCancel = options.validateOnCancel;
    var headerView = options.headerView;
    var bodyView = options.bodyView;
    var footerView = options.footerView;
    var modalBodyClass = options.modalBodyClass;
    var consultation = require('Consultation');
    var deferred = $.Deferred();
    var layout = new Layout({
        deferred: deferred,
        model: new Backbone.Model({
            close: close,
            cancel: cancel,
            header: header,
            save: save
        }),
        validate: validate,
        size: size,
        validateOnCancel: validateOnCancel,
        modalClass: options.modalClass,
        modalBodyClass: modalBodyClass
    });

    consultation.show({ regionName: 'modal', view: layout });
    layout.getRegion('header').show(headerView, { replaceElement: true });
    layout.getRegion('body').show(bodyView);
    layout.getRegion('footer').show(footerView);
    return deferred.promise();
};

module.exports.hide = function (){
    $(Layout.prototype.ui.dialog).modal('hide');
    //Consultation.layout.getRegion('modal').empty();
};


// WEBPACK FOOTER //
// ./js/Modules/Dialog/DialogCustomRegions.js